import { createContext } from 'react';

export const BookingLocationCtx = createContext<{ location: string | null }>({
  location: null,
});
